<template lang="pug">
  el-tabs.tabs(:value="menu" @tab-click="mudarTab")
    template(v-for="tab in tabs")
      el-tab-pane(:name="tab.name")
        span(slot="label")
          | {{tab.label}} &nbsp
    router-view
</template>

<script>
export default {
  methods: {
    mudarTab (componente) {
      const indexTab = this.tabs.findIndex((tab) => tab.name === componente._props.name)
      this.$router.push({
        name: this.tabs[indexTab].name
      })
    }
  },

  data () {
    return {
      tabs: [
        {
          label: 'Meus painéis',
          name: 'home/meusPaineis'

        },
        {
          label: 'Painéis compartilhados',
          name: 'home/paineisCompartilhados'

        }
      ]
    }
  },

  computed: {
    indexTabAtual () {
      return this.tabs.findIndex((tab) => tab.name === this.$route.name)
    },

    menu () {
      return this.$route.name
    }
  }
}
</script>

<style lang="scss" scoped>
>>> .el-tabs__content {
  height: 100%;
}

.tabs {
  height: 100%;
  display: flex;
  flex-direction: column;
}
</style>



// WEBPACK FOOTER //
// src/screens/demandas/Home.vue